var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSwimmer2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 28,
    viewBox: "0 0 35 28",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-3.42%",
    y1: "145.108%",
    x2: "322.188%",
    y2: "-472.76%",
    id: "tttznfq4lb"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#173889",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C3CDEB",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M6.509.576c1.044-.488 1.068-1.344 2.05.89 5.793 1.956 3.16 1.743 4.61-.19 1.332 3.154 2.674 5.71 5.73 4.6-.886 1.19-2.787 3.959-4.15 3.56-3.879 4.542-5.798 2.32-7.295-.625L7.298 8.5a32.066 32.066 0 0 1-.077-.158l-.152-.317-.15-.32-.221-.477-.147-.315C5.797 5.29 5.072 3.83 4.13 3.506c-.456.144-.72.397-.74-.21a10.568 10.568 0 0 0-.754-.173l-.259-.048a25.05 25.05 0 0 0-.257-.045l-.254-.042C.27 2.73-.97 2.598 1.049 1.806m8.85 2.3c-1.77-1.273-1.655-1.457-3.44-1.17 1.442 1.924 2.056 1.032 4.09 5.02",
    id: "vumnt8ik5a"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.179 20.51c-.1.1-.25.24-.25.34-1.754 1.755-2.725 4.83-5.23 3.04-2.712-1.953-3.118-6.603-7.24-5.94-2.61.357-3.024 1.233-3.07.36-.07-1.337 2.627-2.486 3.12-2.72 1.046-.488 1.068-1.343 2.05.89 10.003 3.378 5.854 4.83 7.41.51.624-2.097 5.207.825 3.21 3.52",
    fill: "#F19E8C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.458 8.184c-.096-.048.818-1.42 1.996-1.275 1.178.145 5.507.004 6.782 1.084.815.69 4.935 7.162 1.443 5.818-.626-.24-2.55-3.631-2.862-4.016-.313-.385-4.208-.126-5.53.08-1.324.209-1.829-1.691-1.829-1.691",
    fill: "#F3A391"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.422 7.564c.06-.1 2.86 1.216 2.381 7.593-.609 8.102-10.643 6.937-10.28 2.958.143-1.587 2.514-2.236 3.168-3.174.655-.938-1.543-1.405-1.642-2.585-.078-.937.53-3.002 1.648-4.004 1.118-1.003 4.725-.788 4.725-.788",
    fill: "#F5A997"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.747 7.993s-1.583 1.417-1.008 2.09c1.822 2.133-7.133.825-2.238-4.07l3.246 1.98z",
    fill: "#F3A391"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.432 2.857c3.636 11.13-7.62 4.693-6.962 3.084.162-.396 1.082-.018 1.281.018 1.012.184-1.284-2.343 5.681-3.102",
    fill: "#F8B4A1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.432 3.759c.73-.421-.759-4.49-4.762-3.643-4.496.95-2.927 7.332-.43 7.873.805.174.947-4.23 5.192-4.23",
    fill: "#EA1F16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.519 15.563c.048.289-.193.755 0 .819.143.048.706.225.562-1.702 0 0 1.05 1.09 1.287 1.202.238.113-.017 1.126.333 1.507.508.553.323-1.637-.062-2.292.853.492 1.16.537 1.863 1.59.648.972.26-1.421.032-2.2-.112-.386-2.543-1.544-2.543-1.544-1.462.24-1.935-.157-1.472 2.62",
    fill: "#F7AF9C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.899 18.33c-.941.864-2.455 2.112-3.57 2.73-2.71 1.808-8.207-1.735-4.96-4.98 1.656-1.324 1.404-.223 2.07 1.2.772 1.546 1.023 2.136 6.46 1.05",
    fill: "#EA1F16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.692 11.514c2.27 1.713.253 2.947 1.737 6.818h5.122c1.179-.75 2.169-1.422 2.946-1.55 1.039-.175 2.638.48.204.48l-.53.206c1.585.052 2.856.39 1.997.623-.655.18-.31-.528-2.14.241 2.513 0 2.948 1.21 1.106.457-2.448.323.379.202.577.457.17.22-8.46 1.635-9.643 1.286-1.99-.586-5.096-9.553-1.376-9.018",
    fill: "#F8B4A1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.909 21.17c0 3.699-4.41 6.01-5.21 6.01-2.36 0-5.118-7.882-5.85-8.34-1.816-1.174-7.057-.741-3.8-2.02.8-.32 1.52-.17 2.34-.12.787.036 1.94-.623 2.45-.39.578.258.11.985.62 1.64 1.48 1.976 2.052 1.026 4.09 5.02 2.068-7.811 5.52-4.541 5.36-1.8",
    fill: "#F8B4A1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.598 5.779s.93 3.035.175 4.419c-.755 1.383-4.113 1.399-4.592 1.292-1.353-.303-.818-4.096-.895-4.467-.05-.24.156-1.01.156-1.01s4.056-1.046 5.156-.234M15.692 10.877c1.254-.187 4.067 4.943 1.62 7.139-.365-2.31-3.264-.203-1.89.616-2.507.196-3.723-7.755.27-7.755",
    fill: "#FF6216"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 15.015)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "48rlc1lhsc",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#vumnt8ik5a"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M10.549 7.956C8.515 3.968 7.9 4.86 6.459 2.936c1.785-.287 1.67-.103 3.44 1.17 1.905 1.39 1.027 2.425.65 3.85m2.62-6.68c-1.45 1.933 1.183 2.146-4.61.19C7.577-.768 7.553.088 6.509.576c-4.35 2.06-3.612.49-5.46 1.23-2.655 1.042.33.942 2.34 1.49.02.607.284.354.74.21 3.042 1.049 3.815 13.898 10.62 5.93 1.363.399 3.264-2.37 4.15-3.56-3.056 1.11-4.398-1.446-5.73-4.6",
    fill: "url(#tttznfq4lb)",
    mask: "url(#48rlc1lhsc)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwimmer2);
export default __webpack_public_path__ + "static/media/swimmer2.e39a039dacd7f7a7dbe76788926b36f9.svg";
export { ForwardRef as ReactComponent };